import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import type { IServiceRequestSubscribedFirm } from './types';

export function useSubscribedFirms(serviceRequestId: string | null) {
  const url = serviceRequestId
    ? `service-request/${serviceRequestId}/subscribed-firms`
    : null;

  const { data, error, isLoading, mutate } = useSWR<{
    subscribedFirms: IServiceRequestSubscribedFirm[];
    count: number;
  }>(url, url ? SWRFetcher({ method: 'GET' }) : null);

  return {
    subscribedFirms: data?.subscribedFirms ?? [],
    count: data?.count ?? 0,
    error,
    isLoading,
    mutate,
  };
}
